// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Checkboxes-control-Checkboxes-module__description";
var _2 = "webpack-concepts-Extraction-Blocks-Checkboxes-control-Checkboxes-module__labelOuter";
var _3 = "webpack-concepts-Extraction-Blocks-Checkboxes-control-Checkboxes-module__suggestionPending";
export { _1 as "description", _2 as "labelOuter", _3 as "suggestionPending" }
